import React from 'react'
import { toast} from 'react-toastify'

export default function SuccessMessage(message) {
    return (
        <div>
             {    
        toast.success (message, {
            position: "top-center",
            autoClose: 2500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
        })
    }

        </div>
    )
}

